import { z } from "zod";
import { create } from "zustand";

const editInvoiceSchema = z.object({
  invoiceNum: z.number().optional(),
  unit: z.string().optional(),
  customField: z.string().optional(),
  totalPrice: z.number(),
  unitSize: z.string().optional(),
  taxes: z.number().optional(),
  poBox: z.string().optional(),
  createdAt: z.coerce.date().optional(),
  services: z.array(
    z.object({
      serviceName: z.string().optional(),
      price: z.number().optional(),
      quantity: z.number().optional(),
    }),
  ),
});

type EditInvoiceType = z.infer<typeof editInvoiceSchema>;

interface SelectedInvoice {
  selectedInvoice: EditInvoiceType | null;
  setSelectedInvoice: (selectedInvoice: EditInvoiceType | null) => void;
}

export const useSelectedInvoice = create<SelectedInvoice>()((set) => ({
  selectedInvoice: null,
  setSelectedInvoice: (selectedInvoice) => set({ selectedInvoice }),
}));
